var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFawryIntable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fawry_intable",
    transform: "translate(-396 -879)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12263",
    width: 48,
    height: 24,
    transform: "translate(396 879)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(408 879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46324",
    d: "M51.466,28.066a12,12,0,1,1-3.537-8.507A12,12,0,0,1,51.466,28.066Z",
    transform: "translate(-27.474 -16.068)",
    fill: "#ffd328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46325",
    d: "M60.911,74.869l-1.584-.813s-2.7,5.046-7.424,7.2a11.667,11.667,0,0,1-4.472-2.681,8.027,8.027,0,0,0,4.478-2.481,17.15,17.15,0,0,0,3.552-4.515l-1.236-.846a.639.639,0,0,1-.27-.607.63.63,0,0,1,.409-.518L59.8,67.673a.6.6,0,0,1,.527.059.634.634,0,0,1,.287.458l.807,6.315a.362.362,0,0,1-.147.343A.342.342,0,0,1,60.911,74.869Z",
    transform: "translate(-43.595 -57.824)",
    fill: "#006e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46326",
    d: "M109.6,29.344a.363.363,0,0,1-.7-.072l-.369-2.129L105.794,28a.363.363,0,0,1-.383-.11.37.37,0,0,1-.055-.4,20.543,20.543,0,0,0,1.3-3.745,6.932,6.932,0,0,0-.2-3.888,12,12,0,0,1,4.368,2.791A15.854,15.854,0,0,1,109.6,29.344Z",
    transform: "translate(-90.326 -19.126)",
    fill: "#006e96"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFawryIntable);
export default __webpack_public_path__ + "static/media/fawry_intable.31f13a5323b6ee3b39edd16512d8eddd.svg";
export { ForwardRef as ReactComponent };